import { Link } from 'react-router-dom';

export default function ContainerHero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-teal-600 via-cyan-600 to-teal-700 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
        }}></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 py-20">
        <div className="text-center text-white">
          <div className="inline-flex items-center px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full mb-8">
            <i className="ri-cloud-line mr-2 w-5 h-5 flex items-center justify-center"></i>
            <span className="text-sm font-semibold">云原生容器化解决方案</span>
          </div>

          <h1 className="text-5xl lg:text-7xl font-bold mb-6 leading-tight">
            <span className="block">PDF REST Container</span>
            <span className="block bg-gradient-to-r from-cyan-200 via-teal-200 to-cyan-300 bg-clip-text text-transparent">
              轻量级 · 高性能 · 易部署
            </span>
          </h1>

          <p className="text-xl lg:text-2xl mb-12 max-w-3xl mx-auto leading-relaxed text-white/90">
            基于 Docker 的 PDF 处理微服务，提供 RESTful API 接口，支持快速部署和弹性扩展，让 PDF 处理变得简单高效
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-16">
            <Link 
              to="/contact"
              className="bg-white text-teal-600 hover:bg-gray-50 px-8 py-4 rounded-lg text-lg font-semibold transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer inline-flex items-center justify-center"
            >
              <i className="ri-rocket-line mr-2 w-5 h-5 flex items-center justify-center"></i>
              立即开始
            </Link>
            <a 
              href="#documentation"
              className="border-2 border-white text-white hover:bg-white hover:text-teal-600 px-8 py-4 rounded-lg text-lg font-semibold transition-all whitespace-nowrap cursor-pointer inline-flex items-center justify-center"
            >
              <i className="ri-book-open-line mr-2 w-5 h-5 flex items-center justify-center"></i>
              查看文档
            </a>
          </div>

          {/* Quick Stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 max-w-4xl mx-auto">
            <div className="text-center">
              <div className="text-4xl font-bold mb-2 text-cyan-200">&lt; 100MB</div>
              <div className="text-sm text-white/80">镜像大小</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold mb-2 text-cyan-200">&lt; 5s</div>
              <div className="text-sm text-white/80">启动时间</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold mb-2 text-cyan-200">1000+</div>
              <div className="text-sm text-white/80">并发请求</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold mb-2 text-cyan-200">99.9%</div>
              <div className="text-sm text-white/80">服务可用性</div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-3xl text-white/60"></i>
      </div>
    </section>
  );
}
